import { makeAutoObservable } from "mobx";
import { ENDPOINTS } from "./UserConstant";
import { doGET, doPOST, doPUT, doDELETE } from "../../util/HttpUtil";

class Service {
  records = [];
  STRUCTURE = [];
  page = 1;
  rowsPerPage = 40;
  filterOption = "";
  total = -1;
  version = 0;
  constructor() {
    makeAutoObservable(this);
  };
  client_id = null

  fetch = async (filterUrl) => {

    if (filterUrl) {
      this.filterOption = filterUrl;
    }
    const response = await doGET(
      ENDPOINTS.grid(this.page, this.rowsPerPage, filterUrl, this.client_id)
    );

    if (response?.status === 200) {
      this.records = response.data.rows;
      this.page = response?.data?.page;
      if (this.page === 1) this.total = response?.data?.total;
    }
  };

  fetchComments = async (userId) => {

    const response = await doGET(
      ENDPOINTS.commentGrid(userId)
    );

    if (response?.status === 200) {
      return response.data ? response.data?.rows : response;
    }
  };

  edit = async function (data, id) {
    const response = await doPUT(ENDPOINTS?.update, data);
    if (response.status === 200) {
      this.version += 1;
    }
  };

  get = async (id, client_id) => {
    const response = await doGET(ENDPOINTS.get(id, client_id));

    if (response.status === 200) {
      return response.data ? response.data : response;
    }
  };

  delete = async (id) => {
    const response = await doDELETE(ENDPOINTS.delete(id));
    if (response.status === 200) {
      this.fetch();
    }
  }

  save = async (data) => {
    this.records.push(data);
    const response = await doPOST(ENDPOINTS.save, data);
    return response?.data?._id;
  };

  onPaginationChange = async (page, rowsPerPage) => {
    this.page = page;
    this.rowsPerPage = rowsPerPage;
    await this.fetch(this.filterOption);
  };

  onClientChange = (clientID) => {
    this.client_id = clientID;
    this.fetch()
  };

}

const UserService = new Service();
export default UserService;

